export default __webpack_public_path__ + "static/media/icon_fullscreen.0d08c09d.svg";